type DialogOption = {
  title?: string,
  ok?: string,
  cancel?: string,
}

export function alert(message: string, options: DialogOption = {}) {
  const dialog = document.querySelector('dialog#modal-alert')!.
    cloneNode(true) as HTMLDialogElement;
  dialog.querySelector('.modal-text')!.textContent = message;
  if (options.title)
    dialog.querySelector('.modal-title')!.textContent = options.title;
  if (options.ok)
    dialog.querySelector('.button-modal-ok')!.textContent = options.ok;
  dialog.querySelector('button')!.addEventListener('click', () => {
    dialog.close();
  });
  return new Promise<void>(resolve => {
    dialog.addEventListener('close', () => {
      resolve();
    });
    document.body.append(dialog);
    dialog.showModal();
  });
}

export function confirm(message: string, options: DialogOption = {}) {
  const dialog = document.querySelector('dialog#modal-confirm')!.
    cloneNode(true) as HTMLDialogElement;
  dialog.querySelector('.modal-text')!.textContent = message;
  if (options.title)
    dialog.querySelector('.modal-title')!.textContent = options.title;
  if (options.ok)
    dialog.querySelector('.button-modal-ok')!.textContent = options.ok;
  if (options.cancel)
    dialog.querySelector('.button-modal-cancel')!.textContent = options.cancel;
  return new Promise<boolean>(resolve => {
    const ok = dialog.querySelector('button.button-modal-ok')!;
    ok.addEventListener('click', () => {
      resolve(true);
      dialog.close();
    });
    const cancel = dialog.querySelector('button.button-modal-cancel')!;
    cancel.addEventListener('click', () => {
      dialog.close();
    });
    dialog.addEventListener('close', () => {
      resolve(false);
    });
    document.body.append(dialog);
    dialog.showModal();
  });
}
